export default "../css/9338c7d720b363eea8cbe2bc2bbfff90.ttf";